import { render, staticRenderFns } from "./ObjectLabel.vue?vue&type=template&id=3ecd1c54&"
import script from "./ObjectLabel.vue?vue&type=script&lang=js&"
export * from "./ObjectLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports